module.exports = __webpack_public_path__ + "52a8c52bb5b3b8b39fa14303907bab92.png";